import React, { useEffect, useMemo, useState } from "react";
import axios from "../../utils/axiosConfig";
import { useParams, useNavigate } from "react-router-dom";
import DealNavigation from "../../components/DealNavigation";
import BuyerDetailModal from "../../components/BuyerDetailModal";
import ShipperDetailModal from "../../components/ShipperDetailModal";
import FollowupModal from "../../components/FollowupModal";
import FixationModal from "../../components/FixationModal";
import DealInfoPanel from "../../components/DealInfoPanel";
import { buildFixationPricingDefaults } from "../../utils/fixationDefaults";

const PurchaseContract = () => {
  const { dealId } = useParams();
  const navigate = useNavigate();

  const [deal, setDeal] = useState({});
  const [loading, setLoading] = useState(false);
  const [showDealInfo, setShowDealInfo] = useState(true);
  const [showBuyer, setShowBuyer] = useState(false);
  const [showShipper, setShowShipper] = useState(false);
  const [showFollowup, setShowFollowup] = useState(false);
  const [showFixation, setShowFixation] = useState(false);
  const fixationPricingDefaults = useMemo(() => buildFixationPricingDefaults(deal), [deal]);
  const [formData, setFormData] = useState({
    poRecDate: "",
    poNo: "",
    scDetailDate: ""
  });
  const [documents, setDocuments] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);
  // const [documents, setDocuments] = useState([
  //   "Certificate of Origin",
  //   "Chemical Analysis Report",
  //   "Form 9",
  //   "Insurance Certificate",
  //   "Loading Photographs",
  //   "Original Sales Contract",
  //   "Commercial Invoice",
  //   "Packing List",
  //   "Bill of Lading",
  //   "Pallet Certificate",
  //   "PSIC"
  // ]);

  // const [selectedDocs, setSelectedDocs] = useState([]);

  useEffect(() => {
    if (dealId) {
      fetchDeal();
      fetchDocuments();
    }
  }, [dealId]);

  const fetchDeal = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/container-release/deal/${dealId}`);
      setDeal(res.data || {});
    } catch (err) {
      console.error(err);
      alert("Error loading deal");
    }
    setLoading(false);
  };
  const fetchDocuments = async () => {

    try {

      const res = await axios.get(`/purchase-contract/${dealId}`);

      const documentList = Array.isArray(res.data) ? res.data : (res.data.documents || []);
      setDocuments(documentList);

      const hasSavedSelection = documentList.some(d => d.Flag === 1);
      const selected = hasSavedSelection
        ? documentList.filter(d => d.Flag === 1).map(d => d.Id)
        : documentList.map(d => d.Id);

      setSelectedDocs(selected);
      const details = res.data.details || {};
      setFormData({
        poRecDate: details.PORecDate?.split("T")[0] || "",
        poNo: details.PONo || "",
        scDetailDate: details.SCDetailDate?.split("T")[0] || ""
      });

    } catch (err) {
      console.error(err);
    }

  };

  const handleDocChange = (docId) => {

    if (selectedDocs.includes(docId)) {
      setSelectedDocs(selectedDocs.filter(d => d !== docId));
    } else {
      setSelectedDocs([...selectedDocs, docId]);
    }

  };

  const allDocumentIds = documents.map((doc) => doc.Id);
  const isAllSelected = allDocumentIds.length > 0 && allDocumentIds.every((docId) => selectedDocs.includes(docId));
  const handleSelectAllDocs = (checked) => {
    setSelectedDocs(checked ? allDocumentIds : []);
  };

  const handleSave = async () => {

    if (!formData.poRecDate || !formData.scDetailDate) {
      alert("PO Rec Date and S.C Detail Send Date are required");
      return;
    }

    try {

      await axios.post("/purchase-contract/", {
        dealId,
        poRecDate: formData.poRecDate,
        poNo: formData.poNo,
        scDetailDate: formData.scDetailDate,
        documents: selectedDocs
      });

      alert("Purchase Contract Saved Successfully");
      navigate(`/transaction/sales-contract/${dealId}`);

    }
    catch (err) {

      console.error(err);
      alert("Error saving purchase contract");

    }

  };
  if (loading) return <div className="p-3">Loading...</div>;

  return (
    <>
      <DealNavigation
        dealId={dealId}
        openBuyer={() => setShowBuyer(true)}
        openShipper={() => setShowShipper(true)}
        openFixation={() => setShowFixation(true)}
        openFollowup={() => setShowFollowup(true)}
      />
      <div className="container-fluid mt-3">

        {/* ===== HEADER BADGE ===== */}
        <div className="mb-2">
          <span className="badge bg-success fs-6 px-3 py-2">
            Purchase Contract
          </span>
        </div>


        <DealInfoPanel
          deal={deal}
          show={showDealInfo}
          onToggle={() => setShowDealInfo(!showDealInfo)}
        />

        {/* ================= VIEW DEAL INFO ================= */}
        <div className="border rounded bg-white mb-3 d-none">

          <div
            className="px-3 py-2 border-bottom fw-bold text-muted d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => setShowDealInfo(!showDealInfo)}
          >
            <span className="me-auto">View Deal Info</span>
            <span>{showDealInfo ? "▲" : "▼"}</span>
          </div>

          {showDealInfo && (
            <div className="p-3">

              <div className="purchase-contract-deal-grid">
                {[].map((field) => (
                  <div className="purchase-contract-deal-field" key={field.label}>
                    {field.status && (
                      <div className="purchase-contract-status-row">
                        <span className="badge bg-warning text-dark purchase-contract-status-badge">
                          {field.status}
                        </span>
                      </div>
                    )}
                    <label className="form-label fw-semibold">{field.label}</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={field.value}
                      disabled
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>


        {/* ================= PO DETAILS ================= */}
        <div className="border rounded p-3 bg-white mb-3">

          <div className="row g-3">

            <div className="col-md-3">
              <label className="form-label">PO Rec Date *</label>
              <input
                type="date"
                className="form-control form-control-sm"
                value={formData.poRecDate}
                onChange={(e) => setFormData({ ...formData, poRecDate: e.target.value })}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">PO No</label>
              <input
                type="text"
                className="form-control form-control-sm"
                value={formData.poNo}
                onChange={(e) => setFormData({ ...formData, poNo: e.target.value })}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">S.C Detail Send Date *</label>
              <input
                type="date"
                className="form-control form-control-sm"
                value={formData.scDetailDate}
                onChange={(e) => setFormData({ ...formData, scDetailDate: e.target.value })}
              />
            </div>

          </div>

        </div>


        {/* ================= LIST OF DOCUMENT ================= */}
        <div className="border rounded bg-white mb-3">

          <div className="px-3 py-2 border-bottom fw-bold text-muted">
            List Of Document
          </div>

          <div className="p-3">

            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                checked={isAllSelected}
                onChange={(e) => handleSelectAllDocs(e.target.checked)}
                id="select-all-documents"
              />
              <label className="form-check-label fw-semibold" htmlFor="select-all-documents">
                Select All
              </label>
            </div>

            {documents.map((doc) => (
              <div className="form-check mb-2" key={doc.Id}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedDocs.includes(doc.Id)}
                  onChange={() => handleDocChange(doc.Id)}
                  id={`doc-${doc.Id}`}
                />
                <label className="form-check-label" htmlFor={`doc-${doc.Id}`}>
                  {doc.DocumentName}
                </label>
              </div>
            ))}

          </div>

        </div>


        {/* ================= ACTION BUTTONS ================= */}
        <div className="text-center mb-4">
          <button className="btn btn-success btn-sm me-2" onClick={handleSave}>
            Save
          </button>
          <button className="btn btn-secondary btn-sm">
            Cancel
          </button>
        </div>

      </div>
      <BuyerDetailModal
        show={showBuyer}
        dealId={dealId}
        onClose={() => setShowBuyer(false)}
      />
      <ShipperDetailModal
        show={showShipper}
        dealId={dealId}
        onClose={() => setShowShipper(false)}
      />
      <FixationModal
        show={showFixation}
        dealId={dealId}
        totalQty={deal.TotalQty}
        dealCurrency={deal.DealCurrency}
        dealPricingDefaults={fixationPricingDefaults}
        onClose={() => setShowFixation(false)}
      />
      <FollowupModal
        show={showFollowup}
        dealId={dealId}
        onClose={() => setShowFollowup(false)}
      />
    </>
  );
};

export default PurchaseContract;
